module.exports = __webpack_public_path__ + "img/05-green.ddcb3703.svg";